var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 371.6 318.7",
    enableBackground: "new 0 0 371.6 318.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M155.8,53.8L56,226.7c-8.2,14.2,2.1,32,18.5,32h199.6c16.4,0,26.7-17.8,18.5-32L192.8,53.8 C184.6,39.6,164,39.6,155.8,53.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTriangle);
export default __webpack_public_path__ + "static/media/top_triangle.51c3062e3aa87137e994b3b2fda4060a.svg";
export { ForwardRef as ReactComponent };